import { RouterModule, Routes } from '@angular/router'
import { NgModule } from '@angular/core'
import { ClientAppComponent } from './client-app.component'
import { LoginTokenComponent } from './login-token/login-token.component'
import { ActiveTokenComponent } from './active-token/active-token.component'
import { LoginAccountComponent } from './login-account/login-account.component'
import { ClientGuard } from '../services/guarad/client.guard'

const routes: Routes = [
    { path: 'client/login-token', component: LoginTokenComponent },
    { path: 'client/login-token/click_event/move_to_page_chat', component: LoginTokenComponent },
    { path: 'client/login-token/preview', component: LoginTokenComponent },
    { path: 'client/login-account', component: LoginAccountComponent },
    { path: 'client/activation/:accountId/:token', component: ActiveTokenComponent },
    { path: 'client/preview', component: ActiveTokenComponent },
    { path: 'client/main/:id', canActivate: [ClientGuard], component: ClientAppComponent },
    { path: 'client/main/:id/preview', canActivate: [ClientGuard], component: ClientAppComponent },
    { path: 'client/main/:id/click_event/move_to_page_chat', canActivate: [ClientGuard], component: ClientAppComponent },
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})

export class ClientAppRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/client-app/client-app.routing.ts